module.exports = __webpack_public_path__ + "img/menu_movi.da8cb091.svg";